import script from "./NkGallery.vue?vue&type=script&lang=ts&setup=true"
export * from "./NkGallery.vue?vue&type=script&lang=ts&setup=true"

import "./NkGallery.vue?vue&type=style&index=0&id=3fc79aba&lang=css&scoped=true"
import "./NkGallery.vue?vue&type=style&index=1&id=3fc79aba&lang=scss&scoped=true"
import "./NkGallery.vue?vue&type=style&index=2&id=3fc79aba&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fc79aba"]])

export default __exports__